import { View, StyleSheet } from 'react-native'
import { DS } from '../../../design-system'
import MaterialIcons from '@expo/vector-icons/MaterialIcons'
import { useBreakPointValue } from '../../WebWrapper'
import { DSSpacing } from '../../../design-system/Spacing'

interface IMetricCard {
  title: string
  metric: string
  icon: keyof typeof MaterialIcons.glyphMap
}

export const MetricCard = ({ title, metric, icon }: IMetricCard) => {
  const padding = useBreakPointValue({
    default: 48,
    sm: 24
  })

  return (
    <View style={[styles.container, { padding }]}>
      <DS.Frame gap="12">
        <DS.Text variant="Body Medium/Regular" color="Brand/Dark Grey">
          {title}
        </DS.Text>
      </DS.Frame>
      <DS.Frame row alignItems="flex-end" gap="12" justifyContent="space-between" style={{ flexGrow: 1 }}>
        <DS.Text variant="Heading 2/Medium">{metric}</DS.Text>
        <View style={styles.iconContainer}>
          <MaterialIcons name={icon} size={30} color={DS.palette['Admin/Icon']} />
        </View>
      </DS.Frame>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: DS.palette['Global/White'],
    borderColor: DS.palette['Brand/Light Grey'],
    borderWidth: 1,
    borderRadius: 12,
    gap: 4,
    flex: 1,
    flexGrow: 1
  },
  iconContainer: {
    width: 50,
    height: 50,
    borderRadius: 25,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: DS.palette['Admin/Badge']
  }
})
